export default "__VITE_ASSET__61f7577e__"